<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_2"></a>
<p class="dedi">Also by William McIlvanney</p>
<p class="dedi2">Fiction</p>
<p class="dedi5"><i>Remedy is None</i></p>
<p class="dedi5"><i>Gift from Nessus</i></p>
<p class="dedi5"><i>The Big Man</i></p>
<p class="dedi5"><i>Walking Wounded</i></p>
<p class="dedi5"><i>The Kiln</i></p>
<p class="dedi5"><i>Weekend</i></p>
<p class="dedi2">The Detective Laidlaw trilogy</p>
<p class="dedi5"><i>Laidlaw</i></p>
<p class="dedi5"><i>The Papers of Tony Veitch</i></p>
<p class="dedi5"><i>Strange Loyalties</i></p>
<p class="dedi2">Poetry</p>
<p class="dedi5"><i>The Longships in Harbour</i></p>
<p class="dedi5"><i>In Through the Head</i></p>
<p class="dedi5"><i>These Words: Weddings and After</i></p>
<p class="dedi2">Non Fiction</p>
<p class="dedi5"><i>Shades of Grey – Glasgow 1956–1987, with Oscar Marzaroli</i></p>
<p class="dedi5"><i>Surviving the Shipwreck</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Front01.vue?56f0dbf7